import * as Yup from "yup";
import axios from "axios";
import checkout from "./form";

const {
  formField: {
    name,
    description,
    role,
    partner,
    bio,
    languages,
    interests,
    destinations,
    photo,
    location,
    commission,
    balance,
    locations,
    email,
  },
} = checkout;

const URL = process.env.REACT_APP_API;

const emailCheckValidation = Yup.string()
  .email("Your email address is invalid!")
  .matches(/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/, "Your email address is invalid!")
  .required("Email address is required!")
  .test("checkEmailOnServer", "Email already Exists!", async function checkEmailOnServer(value) {
    if (!value) return true;
    try {
      await axios.post(`${URL}/users/checkEmail`, { email: value });
      return true;
    } catch (err) {
      const msg = err?.response?.data?.msg || "Email already Exists!";
      return this.createError({ message: msg });
    }
  });

const validations = [
  Yup.object().shape({
    [name.name]: Yup.string()
      .matches(/([A-Za-z])/, name.invalidMsg)
      .required(name.errorMsg),
    [role.name]: Yup.string().required(role.errorMsg),
    [email.name]: emailCheckValidation,
  }),
  Yup.object().shape({
    [locations?.name]: Yup.array().when(["partnerPower", "allLocations"], {
      is: (partnerPower, allLocations) => partnerPower === true && allLocations === false,
      then: () => Yup.array().min(1, locations?.errorMsg).required(locations?.errorMsg),
    }),
    // [locations?.name]: Yup.array().when("allLocations", {
    //   is: false,
    //   then: () => Yup.array().min(1, locations?.errorMsg).required(locations?.errorMsg),
    // }),
    [partner.name]: Yup.string().required(partner.errorMsg),
  }),
  Yup.object().shape({
    [bio.name]: Yup.string().required(bio.errorMsg),
    [description.name]: Yup.string().required(description.errorMsg),
    [interests.name]: Yup.array().min(1, interests.errorMsg).required(),
    [languages.name]: Yup.array().min(1, languages.invalidMsg).required(),
    [destinations.name]: Yup.array().min(1, destinations.errorMsg).required(),

    [photo.name]: Yup.string().required(photo.errorMsg).nullable(),
  }),
  Yup.object().shape({
    locDestinations: Yup.object().shape(
      {
        location: Yup.object().when("destinations", {
          is: (desName) => !desName || desName?.length === 0,
          then: () => Yup.object().required(location.errorMsg),
        }),
        destinations: Yup.object().when("location", {
          is: (loc) => !loc || loc?.length === 0,
          then: () => Yup.object().required(destinations.errorMsg),
        }),
      },
      ["destinations", "location"]
    ),
    [balance.name]: Yup.number()
      .min(0, "Initial balance must be at least 0")
      .required(balance.errorMsg),
    [commission.name]: Yup.number()
      .min(0, "Commission must be between 0 and 50")
      .max(50, "Commission must be between 0 and 50")
      .required(commission.errorMsg),
  }),
];

export default validations;
